import React, { Fragment, useState, useEffect, useRef } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './config/sso_config';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfirmDialog } from 'primereact/confirmdialog';
import AppExceptionWrapper from './template/AppExceptionWrapper';
import AppWrapper from './template/AppWrapper';
import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from 'react-cookie';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import store from './services/store';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss'
import './index.css'
import { BrowserView, MobileView } from 'react-device-detect';


const rootElement = document.getElementById('root');
const ReactDOM = createRoot(rootElement);
const msalInstance = new PublicClientApplication(msalConfig);

function IntlApp() {
  const toast = useRef(null);
  return (<Provider store={store}>
    <BrowserRouter basename='/'>
      <AppExceptionWrapper>
        <CookiesProvider>
          <ConfirmDialog />
          <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick
            rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
          <MsalProvider instance={msalInstance}>
            <AppWrapper />
          </MsalProvider>
        </CookiesProvider>
      </AppExceptionWrapper>
    </BrowserRouter>
  </Provider>
  );
}

ReactDOM.render(<IntlApp />);

reportWebVitals();
